module.exports = __webpack_public_path__ + "static/media/logo.01bc9b48.svg";